import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import FieldSet from 'flarum/common/components/FieldSet';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LinkStatus from './LinkStatus';
export default class LinkedAccounts extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      loadingAdditional: true,
      errorLoadingAdditional: false
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.loadLinkedAccounts();
  }
  view() {
    const linkedAccounts = app.store.all('linked-accounts').sort((a, b) => a.name().localeCompare(b.name()));
    return m(FieldSet, {
      label: app.translator.trans('fof-oauth.forum.user.settings.linked-account.label')
    }, m("p", {
      className: "helpText"
    }, app.translator.trans('fof-oauth.forum.user.settings.linked-account.help')), this.state.loadingAdditional ? m(LoadingIndicator, {
      containerClassName: "LinkedAccounts-Loading"
    }) : m("ul", {
      className: "LinkedAccountsList"
    }, listItems(this.linkedAccountsItems(linkedAccounts, this.attrs.user).toArray())));
  }
  linkedAccountsItems(linkedAccounts, user) {
    const items = new ItemList();
    linkedAccounts.forEach(linkedAccount => {
      items.add(linkedAccount.name(), m(LinkStatus, {
        provider: linkedAccount,
        user: user,
        refresh: this.loadLinkedAccounts.bind(this)
      }), linkedAccount.priority());
    });
    return items;
  }
  async loadLinkedAccounts() {
    await app.store.find('linked-accounts', {
      filter: {
        userId: this.attrs.user.id()
      }
    });
    this.state.loadingAdditional = false;
    m.redraw();
  }
}
flarum.reg.add('fof-oauth', 'forum/components/LinkedAccounts', LinkedAccounts);